import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Divider } from "primereact/divider";
import ActiveServices from "./components/ActiveServices";
import RegisteredAddress from "./components/RegisteredAddress";
import VerticalStepper from "../../components/stepper";
import useEntityOnboarding from "./useEntityOnboarding";
import "./entityonboard.scss";
import GeneralInformationForm from "../../components/entities/general-information/GeneralInformationForm";
import NoKeyPersonnel from "../../components/entities/key-personnel/NoKeyPersonnel";
import Personnel from "../../components/entities/key-personnel/Personnel";
import {
  fetchOrganizations,
  postOnboarding,
  setSuccessOnboarding,
} from "./components/entityOnboardSlice";
import { useDispatch, useSelector } from "react-redux";
import apiService from "../../services/service";
import API_ROUTES from "../../api-routes";
import DeleteDialog from "../../components/entities/key-personnel/DeleteDialog";
import Layout from "../../Layout";
import ConfirmationDialog from "../../components/confirmation-dialog/ConfirmationDialog";
import { useCallbackPrompt } from "../../hooks/useCallbackPrommpt";
import { resetInfoData, setInfoData } from "./components/formSlice";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import {
  fetchGlobalEntityDetails,
  fetchServices,
} from "../../components/global-entities/globalEntitiesSlice";
import EntityPlusForm from "~/components/entities/entity-plus/EntityPlusForm";
import InactiveEntityPlus from "~/components/entities/entity-plus/InactiveEntityPlus";
import { resetEntityPlusData } from "~/components/entities/entity-plus/entityPlusSlice";

function validNumber(x) {
  const out = /^(?!\s*$)[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/.test(x || "");
  return out;
}
let addressObj = {
  id: Math.floor(Math.random() * 100),
  type: "Registered",
  country: "",
  address_line_1: "",
  address_line_2: "",
  state: "",
  city: "",
  postalcode: "",
  stateOptions: [],
  cityOptions: [],
};
const EntityOnboard = () => {
  const [formDetails, setFormDetails] = useState({});
  const [btnToggle, setBtnToggle] = useState(true);

  const [btnToggleAdd, setBtnToggleAdd] = useState(true);
  const [personnelState, setPersonnelState] = useState([]);
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const [entityPlusData, setEntityPlusData] = useState({});
  const [regAddData, setRegAddData] = useState([addressObj]);

  const [isCongrats, setIsCongrats] = useState(false);
  const dispatch = useDispatch();
  const [isBtnLoading, setIsBtnLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showPrompt, confirmNavigation, cancelNavigation] =
    useCallbackPrompt(showDialog);
  const navigate = useNavigate();

  const infoData = useSelector((state) => state.form.infoData);

  const { handleSetService, selectedservices, entityservices } =
    useEntityOnboarding();
  const entityPlusService = entityservices.find(
    (service) => service.name === "Entities +",
  );

  const handleConfirmNavigation = () => {
    dispatch(resetInfoData({}));
    dispatch(resetEntityPlusData({}));
    confirmNavigation();
  };

  useEffect(() => {
    if (personnelState.length > 0) {
      setIsNextEnabled(true);
    }
  }, [personnelState]);

  useEffect(() => {
    if (formDetails) {
      handleNext(formDetails);
    }
  }, [formDetails]);

  useEffect(() => {
    dispatch(fetchGlobalEntityDetails());
    dispatch(fetchOrganizations());
    dispatch(fetchServices());
  }, []);

  const steps = [
    {
      label: "General Information",
      content: (
        <GeneralInformationForm
          isEditing={true}
          showGeneralInfo={true}
          formDetails={formDetails}
          setFormDetails={setFormDetails}
          btnToggle={btnToggle}
          setBtnToggle={setBtnToggle}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
          infoData={infoData}
          setInfoData={setInfoData}
          isLoading={isBtnLoading}
          setIsLoading={setIsBtnLoading}
        />
      ),
    },
    {
      label: "Enable Services",
      content: (
        <ActiveServices
          selectedservices={selectedservices}
          setSelectedServices={handleSetService}
          setEntityPlusData={setEntityPlusData}
          entityPlusServiceId={entityPlusService?.id}
        />
      ),
    },
    {
      label: "Configure Services",
      content: (() => {
        if (selectedservices.includes(entityPlusService?.id)) {
          return (
            <EntityPlusForm
              setBtnToggle={setBtnToggle}
              setBtnToggleAdd={setBtnToggleAdd}
              entityPlusData={entityPlusData}
              setEntityPlusData={setEntityPlusData}
              isEditing={true}
              editMode={false}
            />
          );
        } else return <InactiveEntityPlus />;
      })(),
    },

    {
      label: "Addresses",
      content: (
        <RegisteredAddress
          regAddData={regAddData}
          setRegAddData={setRegAddData}
          addressObj={addressObj}
          enableEntityPlus={!selectedservices.includes(entityPlusService?.id)}
        />
      ),
    },

    {
      label: "Key Personnel",
      content: (() => {
        if (personnelState.length === 0) {
          return (
            <NoKeyPersonnel
              showKeyPersonnel={true}
              personnelState={personnelState}
              setPersonnelState={setPersonnelState}
            />
          );
        } else {
          return (
            <Personnel
              showKeyPersonnel={true}
              personnelState={personnelState}
              setPersonnelState={setPersonnelState}
              isCongrats={isCongrats}
              showHistoryBtn={false}
            />
          );
        }
      })(),
    },
  ];
  const {
    handleBack,
    handleNext,
    activeIndex,
    showDeleteModal,
    leave,
    setLeave,
  } = useEntityOnboarding(steps, personnelState);

  function validateAll(dataArray) {
    for (const item of dataArray) {
      if (
        !item.country ||
        !item.country.name ||
        !item.country.code ||
        !item.type?.trim() ||
        !item.address_line_1?.trim() ||
        !item.postalcode?.trim() ||
        !validNumber(item.postalcode)
      ) {
        return false;
      }
    }
    return true;
  }

  useEffect(() => {
    if (activeIndex == 3) {
      const isValid = validateAll(regAddData);

      setBtnToggle(!isValid);
      setBtnToggleAdd(!isValid);
    }
  }, [regAddData, activeIndex]);

  useEffect(() => {
    if (activeIndex == 1) {
      setBtnToggle(!(selectedservices.length > 0));
      setBtnToggleAdd(!(selectedservices.length > 0));
    }
  }, [selectedservices, activeIndex]);

  const handlePersonnelSubmit = async () => {
    const addressdata = regAddData.map(
      ({ id, stateOptions, cityOptions, country, state, city, ...rest }) => ({
        ...rest,
        country: country?.code || "",
        state: state?.code || "",
        city: city?.code || "",
      }),
    );
    if (
      personnelState.length > 0 &&
      formDetails &&
      selectedservices &&
      addressdata.length > 0 &&
      (!selectedservices.includes(entityPlusService?.id) ||
        (selectedservices.includes(entityPlusService?.id) && entityPlusData))
    ) {
      setIsBtnLoading(true);
      const onboardingData = {
        name: formDetails?.name,
        trading_name: formDetails?.trading_name,
        tax_id: formDetails?.tax_id,
        country:
          typeof formDetails?.country === "object"
            ? formDetails?.country?.code
            : formDetails?.country,
        registration_number: formDetails?.registration_number,
        type:
          typeof formDetails?.type === "object"
            ? formDetails?.type?.code
            : formDetails?.type,
        status:
          typeof formDetails?.status === "object"
            ? formDetails.status?.code
            : formDetails?.status,
        business_activity:
          typeof formDetails?.business_activity === "object"
            ? formDetails?.business_activity?.code
            : formDetails?.business_activity,
        salesforce_id: formDetails?.salesforce_id,
        account_manager_name: formDetails.account_manager_name,
        account_manager_email: formDetails.account_manager_email,
        parent: formDetails.parent ? formDetails.parent : null,
        organization: formDetails.organization,
        active_services: selectedservices,
        domains: ["3pillarglobal.com", "3pillarglobal.in"],
        address: addressdata,
        keypersonnels: personnelState.map((person) => ({
          role: person?.role,
          name: person?.name,
          last_name: person?.last_name,
          preferred_name: person?.preferred_name,
          other_name: person?.other_name,
          email: person?.email,
          phone: person?.phone,
          country: person?.country,
          phone_code: person?.phone_code,
        })),
        timezone: formDetails?.timezone,
        entityPlusData: entityPlusData,
      };

      const apiRoute = API_ROUTES.ONBOARDING;

      try {
        const res = await apiService(apiRoute, "POST", {
          body: JSON.stringify(onboardingData),
        });
        if (res.status) {
          dispatch(setSuccessOnboarding(res.data));
        } else {
          console.log("Not getting response");
        }
        setIsBtnLoading(false);
      } catch (error) {
        console.error(error);
        setIsBtnLoading(false);
      }

      setIsCongrats(true);
      handleNext(onboardingData);
    }
  };

  const handleCancel = () => {
    showDeleteModal();
  };

  return (
    <Layout
      crumbs={[
        {
          label: (
            <span style={{ textDecoration: "underline", cursor: "pointer" }}>
              My Entities
            </span>
          ),
          command: () => navigate("/entities"),
          id: "entities",
        },
        { label: "Add New Entity", id: "add-entity" },
      ]}
    >
      <ConfirmationDialog
        show={showPrompt}
        onConfirm={handleConfirmNavigation}
        onCancel={cancelNavigation}
      />
      <div className="grid entity-onboarding">
        <div className="lg:col-3 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">
            <p className="add-new-entity-heading">Add New Entity</p>
            <p className="input-label m-0">
              Complete the necessary steps to onboard a new entity
            </p>
            <Divider />
            <div className="step-menu">
              <VerticalStepper options={steps} activeIndex={activeIndex} />
            </div>
          </Card>
        </div>
        <div className="lg:col-9 md:col-12 sm:col-12 xs:col-12 pt-4">
          <Card className="card-onboard">{steps[activeIndex].content}</Card>
          {!isCongrats ? (
            <div className="next-btn-footer">
              {activeIndex !== 0 ? (
                <>
                  <div className="d-flex justify-content-start">
                    <button
                      type="button"
                      className="generic-cancel"
                      onClick={() => {
                        navigate(-1);
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                </>
              ) : null}
              {activeIndex === 0 ? <div></div> : <div></div>}
              <div className="flex justify-content-end gap-2">
                {activeIndex === 0 ? (
                  <button
                    type="button"
                    className="cancel-btns"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    Cancel
                  </button>
                ) : null}
                {activeIndex === 0 ? (
                  ""
                ) : (
                  <button
                    type="button"
                    onClick={handleBack}
                    disabled={activeIndex === 0}
                    className="cancel-btns"
                  >
                    Back
                  </button>
                )}
                {activeIndex === steps.length - 1 ? (
                  <Button
                    type="submit"
                    className={`add-new-contact complete-onboard-btn ${!isNextEnabled && "disable"}`}
                    loading={isBtnLoading}
                    onClick={() => {
                      handlePersonnelSubmit();
                      setShowDialog(false);
                    }}
                  >
                    {!isBtnLoading && "Complete Onboarding"}
                  </Button>
                ) : (
                  <button
                    form="114490"
                    type="submit"
                    onClick={activeIndex !== 0 ? handleNext : undefined}
                    disabled={btnToggleAdd && btnToggle}
                    className={`add-new-contact  ${btnToggleAdd && btnToggle && "disable"}`}
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          ) : null}
        </div>
      </div>

      <DeleteDialog
        visible={leave}
        onHide={() => setLeave(false)}
        leave={leave}
      />
    </Layout>
  );
};

export default EntityOnboard;
